import {
  getPoolGridData,
  getPurchaseTypeDropdown,
  getRegisteredDropdown,
  getOrderTypeDropdown,
  getClientCodeDropdown,
  getReasonCodeDropdown,
  getAssignToDropdown,
  getCapexDropdown,
  setVendorDetails,
  getVendorDetails,
  setPurchaseorderStepperData,
  setError,
  getChangeLogs,
  setPurchaseorderStepperInfo,
  updateReasonCode,
  getEqClassCodeDropdown
} from "./action";

const dispatchPoolGridData = (dispatch: Function) => (subTypeId: any) => {
  dispatch(getPoolGridData(subTypeId));
};
const dispatchPurchaseTypeDropdown = (dispatch: Function) => () => {
  dispatch(getPurchaseTypeDropdown());
};
const dispatchRegisteredDropdown = (dispatch: Function) => () => {
  dispatch(getRegisteredDropdown());
};
const dispatchOrderTypeDropdown = (dispatch: Function) => () => {
  dispatch(getOrderTypeDropdown());
};
const dispatchClientCodeDropdown = (dispatch: Function) => () => {
  dispatch(getClientCodeDropdown());
};
const dispatchReasonCodeDropdown = (dispatch: Function) => () => {
  dispatch(getReasonCodeDropdown());
};
const dispatchCapexDropdown = (dispatch: Function) => () => {
  dispatch(getCapexDropdown());
};
const dispatchAssignToDropdown = (dispatch: Function) => () => {
  dispatch(getAssignToDropdown());
};

const dispatchSetVendorDetails =
  (dispatch: Function) => (addressBookNo: any) => {
    dispatch(setVendorDetails(addressBookNo));
  };

const dispatchGetVendorDetails =
  (dispatch: Function) => (addressBookNo: any) => {
    dispatch(getVendorDetails(addressBookNo));
  };

const dispatchSetPurchaseorderStepperData =
  (dispatch: Function) => (data: any) => {
    dispatch(setPurchaseorderStepperData(data));
  };

const dispatchSetPurchaseorderStepperInfo =
  (dispatch: Function) => (data: any) => {
    dispatch(setPurchaseorderStepperInfo(data));
  };

const dispatchSetError = (dispatch: Function) => (data: any) => {
  dispatch(setError(data));
};

const dispatchChangeLogs = (dispatch: Function) => (data: any) => {
  dispatch(getChangeLogs(data));
};

const dispatchUpdateReasonCode = (dispatch: Function) => (data: any) => {
  dispatch(updateReasonCode(data));
}

const dispatchGetEqClassCodeDropdown = (dispatch: Function) => () => {
  dispatch(getEqClassCodeDropdown());
};

const operations = {
  dispatchPoolGridData,
  dispatchPurchaseTypeDropdown,
  dispatchRegisteredDropdown,
  dispatchOrderTypeDropdown,
  dispatchClientCodeDropdown,
  dispatchReasonCodeDropdown,
  dispatchCapexDropdown,
  dispatchAssignToDropdown,
  dispatchSetVendorDetails,
  dispatchGetVendorDetails,
  dispatchSetPurchaseorderStepperData,
  dispatchSetError,
  dispatchChangeLogs,
  dispatchSetPurchaseorderStepperInfo,
  dispatchUpdateReasonCode,
  dispatchGetEqClassCodeDropdown
};

export default operations;
